class OrderHistoryPaginationController {

    constructor($window, $timeout) {
        this.$window = $window;
        this.$timeout = $timeout;
    }

    getPage (pageNumber) {
        this.loading = true;
        return this.callback({ timeframe: this.timeframe, page: pageNumber })
            .then(() => {
                this.loading = false;
                this.$timeout(() => {
                    this.$window.document.getElementById(this.timeframe).scrollIntoView({ behavior: "smooth" });
                });
            });
    }

    getPreviousPage () {
        return this.getPage(this.orders.current_page - 1);
    }

    getNextPage () {
        return this.getPage(this.orders.current_page + 1);
    }

    isPage (pageNumber) {
        return this.orders.current_page === pageNumber;
    }

    generatePages () {
        let pages = [];

        if (this.orders.last_page > 1) {
            let startPage = 1;
            let endPage = this.orders.last_page;

            if (this.orders.last_page > 10) {
                if (this.orders.current_page <= 5) {
                    startPage = 1;
                    endPage = 10;
                } else if (this.orders.current_page + 4 >= this.orders.last_page) {
                    startPage = this.orders.last_page - 9;
                    endPage = this.orders.last_page;
                } else {
                    startPage = this.orders.current_page - 5;
                    endPage = this.orders.current_page + 4;
                }
            }

            pages = this.interpolatePages(startPage, endPage);
        }

        return pages;
    }

    interpolatePages (startPage, endPage) {
        return Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
    }
}

OrderHistoryPaginationController.$inject = ['$window', '$timeout'];

export default OrderHistoryPaginationController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/controllers/order.history.pagination.controller.js